export const SOCIAL_EMAIL_ACCOUNT_EXISTS_ERRORS = [
    'common.errors.googleEmailAccountExists',
    'common.errors.appleEmailAccountExists',
] as const

export type SocialEmailAccountExistsError = (typeof SOCIAL_EMAIL_ACCOUNT_EXISTS_ERRORS)[number]

export const isSocialEmailAccountExistsError = (
    message: string,
): message is SocialEmailAccountExistsError =>
    (SOCIAL_EMAIL_ACCOUNT_EXISTS_ERRORS as readonly string[]).includes(message)

export const readIdTokenEmail = (idToken: string): string | undefined => {
    try {
        const segment = (idToken.split('.')[1] ?? '').replace(/-/g, '+').replace(/_/g, '/')
        const padded = segment.padEnd(Math.ceil(segment.length / 4) * 4, '=')
        const { email } = JSON.parse(atob(padded)) as { email?: unknown }

        return typeof email === 'string' ? email : undefined
    } catch {
        return undefined
    }
}
